export default __webpack_public_path__ + "static/media/AshleeChantzFront.540d1fd3.jpeg";